module.exports = __webpack_public_path__ + "static/media/cc_icon-accel.0f4321f4.svg";